var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6235 5.63944C18.5218 5.2564 18.3213 4.90679 18.042 4.62564C17.7626 4.34448 17.4144 4.14165 17.032 4.03744C15.6287 3.65869 10 3.65869 10 3.65869C10 3.65869 4.37125 3.65869 2.96725 4.03744C2.58506 4.14183 2.23697 4.34474 1.95781 4.62588C1.67865 4.90701 1.47819 5.25652 1.3765 5.63944C1 7.05244 1 9.99994 1 9.99994C1 9.99994 1 12.9474 1.3765 14.3604C1.47819 14.7435 1.67873 15.0931 1.95804 15.3742C2.23736 15.6554 2.58563 15.8582 2.968 15.9624C4.37125 16.3412 10 16.3412 10 16.3412C10 16.3412 15.6288 16.3412 17.0328 15.9624C17.4152 15.8583 17.7635 15.6555 18.0428 15.3743C18.3221 15.0932 18.5226 14.7435 18.6243 14.3604C19 12.9474 19 9.99994 19 9.99994C19 9.99994 19 7.05244 18.6235 5.63944ZM8.15875 12.6759V7.32394L12.8635 9.99994L8.15875 12.6759Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e3160c095bcd2e44c40924243947d988.svg";
export { ForwardRef as ReactComponent };